// extracted by mini-css-extract-plugin
module.exports = {"tx_green":"FooterFixed_tx_green__29odE","content_footer_fix":"FooterFixed_content_footer_fix__3_pA0","col_mb":"FooterFixed_col_mb__1ziVU"};